
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActivityTarget": [
      "Group",
      "Question",
      "Resource",
      "User",
      "Workspace"
    ],
    "DocumentMetadata": [
      "CustomerAgreementMetadataType",
      "EmployeeAgreementMetadataType",
      "GenericDocumentMetadataType",
      "LeaseMetadataType"
    ],
    "NotificationTarget": [
      "Question",
      "Resource",
      "Workspace"
    ]
  }
};
      export default result;
    